import { render, staticRenderFns } from "./ClaimApproval.vue?vue&type=template&id=aa402bda&scoped=true"
import script from "./ClaimApproval.vue?vue&type=script&lang=js"
export * from "./ClaimApproval.vue?vue&type=script&lang=js"
import style0 from "./ClaimApproval.vue?vue&type=style&index=0&id=aa402bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa402bda",
  null
  
)

export default component.exports